import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '~/App';
import { ReduxProvider } from '~/redux/provider';
import '~/locales';
import 'react-loading-skeleton/dist/skeleton.css';
import '~/index.css';
import '~/skeleton.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <React.Suspense>
      <ReduxProvider>
        <App />
        {/*  */}
      </ReduxProvider>
    </React.Suspense>
  </React.StrictMode>,
);
